import { Button, Spin } from "antd";
import { LoadingOutlined, ShareAltOutlined } from "@ant-design/icons";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { useEffect, useState } from "react";

const CountdownTimer = ({ handleSocialMedia, data }: any) => {
  const [loading, setLoading] = useState(false);
  const state: any = useAppSelector((state) => state.profile?.userData);
  const createdDate = data?.end_date;

  const storedRemainingDays = localStorage.getItem("remainingDays");
  const initialRemainingDays = storedRemainingDays
    ? parseInt(storedRemainingDays, 10)
    : moment(createdDate).diff(moment(), "days");

  useEffect(() => {
    localStorage.setItem("remainingDays", initialRemainingDays.toString());

    setLoading(!loading);
  }, []);

  const renderer = ({ days, hours, minutes, seconds }: any) => {
    return (
      <div className="counter">
        <div className="time">
          <h3>{zeroPad(days)}&nbsp;:</h3>
          <h5>Days</h5>
        </div>
        <div className="time">
          <h3>{zeroPad(hours)}&nbsp;:</h3>
          <h5>Hrs</h5>
        </div>
        <div className="time">
          <h3>{zeroPad(minutes)}&nbsp;:</h3>
          <h5>Mins</h5>
        </div>
        <div className="time">
          <h3>{zeroPad(seconds)}</h3>
          <h5>Secs</h5>
        </div>
      </div>
    );
  };

  return (
    <div
      className="share__content"
      style={{ display: "flex", flexWrap: "nowrap" }}
    >
      <div className="text">
        {/* <h4>Cash Back ends in:</h4> */}
        <h4>
          Share this link — you’ll earn 5% every time they pay and renew.
        </h4>
      </div>
      {/* {state ? (
        <>
          <Countdown
            date={moment(createdDate)
              .add(initialRemainingDays, "days")
              .toDate()}
            renderer={renderer}
            key={createdDate}
          />
        </>
      ) : (
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      )} */}

      <div className="cta-btn">
        <Button
          className="btn-primary"
          icon={<ShareAltOutlined />}
          onClick={handleSocialMedia}
        >
          Share
        </Button>
      </div>
    </div>
  );
};
export default CountdownTimer;
